"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Three3DScene = void 0;
var _three = require("three");
var _Three3D2 = require("./Three3D");
var _isMobileDevice = require("../Utils/isMobileDevice");
var _GLTFLoader = require("three/examples/jsm/loaders/GLTFLoader");
var _DRACOLoader = require("three/examples/jsm/loaders/DRACOLoader");
var _RGBELoader = require("three/examples/jsm/loaders/RGBELoader");
var _get = _interopRequireDefault(require("lodash/get"));
var _size = _interopRequireDefault(require("lodash/size"));
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var _glTFExporter = require("./Exporters/glTFExporter");
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _createBakedShadow = _interopRequireDefault(require("../Utils/createBakedShadow"));
var _setLightShadow2 = _interopRequireDefault(require("../Utils/setLightShadow"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var UNSET = Symbol("unset");
var allowedObjectProps = ["position", "rotation", "scale"];
function getSrc(item) {
  return item && (item.model || item.src);
}
function getPatch(oldObj, newObj) {
  var patch = {};
  newObj && Object.keys(newObj).forEach(function (prop) {
    if ((0, _isPlainObject["default"])(newObj[prop])) {
      var objPatch = getPatch(oldObj && oldObj[prop], newObj[prop]);
      if (Object.keys(objPatch).length) {
        patch[prop] = objPatch;
      }
    } else {
      patch[prop] = newObj[prop];
    }
  });
  oldObj && Object.keys(oldObj).forEach(function (prop) {
    if (!newObj.hasOwnProperty(prop)) {
      if ((0, _isPlainObject["default"])(_typeof(newObj[prop]))) {
        var objPatch = getPatch(oldObj[prop], newObj[prop]);
        if (Object.keys(objPatch).length) {
          patch[prop] = objPatch;
        }
      } else {
        patch[prop] = UNSET;
      }
    }
  });
  return patch;
}
function disposeNonUsedObjects(root, disposeTarget) {
  var disposableObjects = [];
  disposeTarget.traverse(function (_ref) {
    var geometry = _ref.geometry,
      material = _ref.material;
    geometry && disposableObjects.push(geometry);
    material && disposableObjects.push(material);
    material && disposableObjects.push.apply(disposableObjects, _toConsumableArray(Object.values(material).filter(function (value) {
      return value && value.isTexture;
    })));
  });
  var referencedObjects = [];
  root.traverse(function (_ref2) {
    var geometry = _ref2.geometry,
      material = _ref2.material;
    geometry && referencedObjects.push(geometry);
    material && referencedObjects.push(material);
    material && referencedObjects.push.apply(referencedObjects, _toConsumableArray(Object.values(material).filter(function (value) {
      return value && value.isTexture;
    })));
  });
  for (var _i = 0, _disposableObjects = disposableObjects; _i < _disposableObjects.length; _i++) {
    var object = _disposableObjects[_i];
    if (referencedObjects.indexOf(object) === -1) {
      object.dispose();
    }
  }
}
function getMaterials(tree) {
  var materials = {};
  tree.traverse(function (_ref3) {
    var material = _ref3.material;
    if (material) {
      materials[material.name] = material;
    }
  });
  return materials;
}
function getAllMaterials(tree) {
  var materials = [];
  tree.traverse(function (_ref4) {
    var material = _ref4.material;
    if (material && materials.indexOf(material) === -1) {
      materials.push(material);
    }
  });
  return materials;
}
function findImageBySrc(tree, src) {
  var result = null;
  tree.traverse(function (_ref5) {
    var material = _ref5.material;
    if (!result && material) {
      for (var _i2 = 0, _Object$values = Object.values(material); _i2 < _Object$values.length; _i2++) {
        var value = _Object$values[_i2];
        if (value && value.isTexture && value.image && value.image.src === src) {
          result = value.image;
        }
      }
    }
  });
  return result;
}
function createIndexCounter() {
  var counters = {};
  var add = function add(index) {
    if (undefined === counters[index]) {
      counters[index] = 0;
    } else {
      counters[index]++;
    }
    return counters[index];
  };
  var reset = function reset() {
    counters = {};
  };
  return {
    add: add,
    reset: reset
  };
}
function diffResourceLists(oldList, newList) {
  var toBeRemoved = [];
  var toBeAdded = [];
  var toBeUpdated = [];
  var toBeApplied = [];
  var indexCounter = createIndexCounter();
  var _iterator = _createForOfIteratorHelper(oldList),
    _step;
  try {
    var _loop = function _loop() {
      var item = _step.value;
      var src = getSrc(item);
      if (!src) {
        return 1; // continue
      }
      var index = indexCounter.add(src);
      var newItem = newList.filter(function (newItem) {
        return getSrc(newItem) === src;
      })[index];
      if (!newItem) {
        toBeRemoved.push(_objectSpread(_objectSpread({}, item), {}, {
          index: index
        }));
      } else {
        var patch = getPatch(item, newItem);
        if (Object.keys(patch).length) {
          toBeUpdated.push(_objectSpread(_objectSpread({}, patch), {}, {
            model: src,
            index: index
          }));
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  indexCounter.reset();
  var _iterator2 = _createForOfIteratorHelper(newList),
    _step2;
  try {
    var _loop2 = function _loop2() {
      var item = _step2.value;
      var src = getSrc(item);
      if (!src) {
        item.params && toBeApplied.push(item);
        return 1; // continue
      }
      var index = indexCounter.add(src);
      if (!oldList.filter(function (oldItem) {
        return getSrc(oldItem) === src;
      })[index]) {
        toBeAdded.push(_objectSpread(_objectSpread({}, item), {}, {
          index: index
        }));
      }
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      if (_loop2()) continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    toBeRemoved: toBeRemoved,
    toBeAdded: toBeAdded,
    toBeUpdated: toBeUpdated,
    toBeApplied: toBeApplied
  };
}
function findObjectWith(root, testFn) {
  var result = null;
  root.traverse(function (object) {
    if (!result && testFn(object)) {
      result = object;
    }
  });
  return result;
}
function findAllObjectsWith(root, testFn) {
  var result = [];
  root.traverse(function (object) {
    return testFn(object) && result.push(object);
  });
  return result;
}
function mapObjectValues(object, valueMap) {
  return Object.keys(object).reduce(function (res, key) {
    return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, valueMap && valueMap[object[key]] || object[key]));
  }, {});
}
function setCameraAspectFromRendererSize(camera, renderer) {
  var _renderer$domElement = renderer.domElement,
    width = _renderer$domElement.width,
    height = _renderer$domElement.height;
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
}
var Three3DScene = exports.Three3DScene = /*#__PURE__*/function (_Three3D) {
  _inherits(Three3DScene, _Three3D);
  var _super = _createSuper(Three3DScene);
  function Three3DScene() {
    var _this;
    var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Three3DScene);
    _this = _super.call(this, cfg);
    _defineProperty(_assertThisInitialized(_this), "DefaultCustomizableMaterialKey", "CustomizableMaterial");
    _defineProperty(_assertThisInitialized(_this), "clock", new _three.Clock());
    _defineProperty(_assertThisInitialized(_this), "animations", []);
    _defineProperty(_assertThisInitialized(_this), "currentResourceList", []);
    _defineProperty(_assertThisInitialized(_this), "sceneContainer", function () {
      var g = new _three.Group();
      g.name = "sceneContainer";
      return g;
    }());
    _defineProperty(_assertThisInitialized(_this), "mixer", new _three.AnimationMixer(_this.sceneContainer));
    _defineProperty(_assertThisInitialized(_this), "defaultCamera", null);
    _defineProperty(_assertThisInitialized(_this), "dirLightPosition", new _three.Vector3(1, 1, 1).normalize());
    _defineProperty(_assertThisInitialized(_this), "defaultCameraPosition", new _three.Vector3(0, 1, 2).normalize());
    _defineProperty(_assertThisInitialized(_this), "defaultScreenshotPosition", new _three.Vector3(0, 0, 1).normalize());
    _defineProperty(_assertThisInitialized(_this), "relativeCameraViews", {});
    _defineProperty(_assertThisInitialized(_this), "relativeScreenshotViews", {});
    _defineProperty(_assertThisInitialized(_this), "groundObjectNames", [/ground/i]);
    _defineProperty(_assertThisInitialized(_this), "config", {
      useShadowGround: true,
      removeGroundForScreenshot: true,
      useEnvironmentMap: true,
      useDirectionalLight: false,
      useBakedShadows: false,
      bakedShadow: {
        lightPositionOffset: {
          x: 0,
          y: 0,
          z: 0
        },
        shadowMapSize: 512,
        groundScaling: 2,
        shadowTextureScaling: 0.96,
        blurRadius: 6,
        shadowOpacity: 0.8
      }
    });
    _defineProperty(_assertThisInitialized(_this), "animate", function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!_this._isAnimating) {
        window.cancelAnimationFrame(_this._animationFrame);
        _this._animationFrame = null;
        return;
      }
      _this._animationFrame = window.requestAnimationFrame(_this.animate);
      if (time) {
        var delta = _this.clock.getDelta();
        _this.mixer.update(delta);
        _this.cameraTweenGroup.update(time);
        if (_this.controls) {
          _this.controls.update();
        }
        _this.render();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "helpers", {
      addDirectionalLightHelper: function addDirectionalLightHelper() {
        var _assertThisInitialize = _assertThisInitialized(_this),
          dirLight = _assertThisInitialize.dirLight;
        var cameraHelper = new _three.CameraHelper(dirLight.shadow.camera);
        _this.scene.add(cameraHelper);
      },
      addSceneSphereHelper: function addSceneSphereHelper() {
        var box = _this.getSceneContainerBox();
        var sphere = new _three.Sphere();
        box.getBoundingSphere(sphere);
        var sphereMesh = new _three.Mesh(new _three.SphereGeometry(sphere.radius, 32, 32), new _three.MeshBasicMaterial({
          color: 0x66ff66,
          wireframe: true
        }));
        sphereMesh.position.copy(sphere.center);
        _this.scene.add(sphereMesh);
      }
    });
    cfg.modelBasePath ? _this._modelBasePath = cfg.modelBasePath : _this._modelBasePath = "";
    return _this;
  }
  _createClass(Three3DScene, [{
    key: "setOptions3D",
    value: function setOptions3D(options) {
      (0, _merge["default"])(this.config, options);
    }
  }, {
    key: "createLoadingManager",
    value: function createLoadingManager() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$basePath = options.basePath,
        basePath = _options$basePath === void 0 ? "" : _options$basePath,
        _options$resourcePath = options.resourcePath,
        resourcePath = _options$resourcePath === void 0 ? "/" : _options$resourcePath;
      var _this$_loadingManager = this._loadingManager,
        onLoad = _this$_loadingManager.onLoad,
        onProgress = _this$_loadingManager.onProgress,
        onError = _this$_loadingManager.onError;
      var loadingManager = new _three.LoadingManager(onLoad, onProgress, onError);
      loadingManager.setURLModifier(function (url) {
        if (/^(data|blob):/.test(url)) {
          return url;
        }
        var fixedBasePath = basePath.replace(/\/$/, "");
        return url.indexOf("/") === 0 ? "".concat(fixedBasePath).concat(url) : "".concat(fixedBasePath).concat(resourcePath).concat(url.replace("./", ""));
      });
      return loadingManager;
    }
  }, {
    key: "createLoader",
    value: function createLoader() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var loadingManager = this.createLoadingManager(options);
      var dracoLoader = new _DRACOLoader.DRACOLoader();
      dracoLoader.setDecoderPath("libs/draco/gltf/");
      var loader = new _GLTFLoader.GLTFLoader(loadingManager);
      loader.setDRACOLoader(dracoLoader);
      return loader;
    }
  }, {
    key: "createImageLoader",
    value: function createImageLoader() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var loadingManager = this.createLoadingManager(options);
      var imageLoader = new _three.ImageLoader(loadingManager);
      return imageLoader;
    }
  }, {
    key: "createRenderer",
    value: function createRenderer() {
      var renderer = new _three.WebGLRenderer({
        alpha: true,
        antialias: true
      });
      renderer.outputEncoding = _three.sRGBEncoding;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = _three.PCFSoftShadowMap;
      renderer.toneMapping = _three.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1;
      var realWidth = window.innerWidth * window.devicePixelRatio;
      if ((0, _isMobileDevice.isMobileDevice)() && realWidth >= 1024) {
        renderer.setPixelRatio(1);
      } else {
        renderer.setPixelRatio(window.devicePixelRatio);
      }
      this.config.useEnvironmentMap && this.loadEnvMap(renderer);
      return renderer;
    }
  }, {
    key: "getDefaultEnvMapURL",
    value: function getDefaultEnvMapURL() {
      return "hdr/envmap.hdr";
    }
  }, {
    key: "loadEnvMap",
    value: function loadEnvMap(renderer) {
      var _this2 = this;
      var envMapURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getDefaultEnvMapURL();
      if (this.config.useEnvironmentMap) {
        var pmremGenerator = new _three.PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();
        this.envMapPromise = new Promise(function (resolve, reject) {
          new _RGBELoader.RGBELoader().setDataType(_three.UnsignedByteType).load(envMapURL, function (texture) {
            _this2.envMap = pmremGenerator.fromEquirectangular(texture).texture;
            _this2.scene.environment = _this2.envMap;
            texture.dispose();
            pmremGenerator.dispose();
            resolve(_this2.envMap);
          }, undefined, reject);
        });
      }
    }
  }, {
    key: "createCamera",
    value: function createCamera() {
      var camera = new _three.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.01);
      camera.position.copy(this.defaultCameraPosition).multiplyScalar(1000);
      return camera;
    }
  }, {
    key: "setupDefaultLightning",
    value: function setupDefaultLightning() {}
  }, {
    key: "loadModel",
    value: function loadModel() {}
  }, {
    key: "createScene",
    value: function createScene() {
      var scene = new _three.Scene();
      scene.add(this.sceneContainer);
      if (this.config.useEnvironmentMap && this.envMap) {
        scene.environment = this.envMap;
      }
      if (this.config.useDirectionalLight) {
        scene.add(this.createDirLight());
      }
      return scene;
    }
  }, {
    key: "createGround",
    value: function createGround() {
      this.ground && this.scene.remove(this.ground);
      var shadowMaterial;
      if (this.config.useBakedShadows) {
        shadowMaterial = (0, _createBakedShadow["default"])(this.scene, {
          withMaterial: true,
          config: this.config.bakedShadow
        });
      } else {
        shadowMaterial = new _three.ShadowMaterial({
          color: 0x202020
        });
      }
      var mesh = new _three.Mesh(new _three.PlaneBufferGeometry(1, 1), shadowMaterial);
      mesh.name = "ground";
      mesh.rotation.x = -Math.PI / 2;
      mesh.receiveShadow = true;
      this.ground = mesh;
      return mesh;
    }
  }, {
    key: "setLightShadow",
    value: function setLightShadow(light) {
      var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      (0, _setLightShadow2["default"])(light, d, (0, _merge["default"])({}, {
        shadowMapSize: 1024,
        cameraProps: {
          far: 10000
        }
      }, options));
    }
  }, {
    key: "createDirLight",
    value: function createDirLight() {
      var dirLight = new _three.DirectionalLight(0xffffff, 1);
      dirLight.name = "dirLight";
      dirLight.position.set(1, 1, 1).normalize();
      this.setLightShadow(dirLight);
      this.dirLight = dirLight;
      return dirLight;
    }
  }, {
    key: "addLightsIfNeeded",
    value: function addLightsIfNeeded(scene) {
      var sceneHasLight = scene.getObjectByProperty("isLight", true);
      if (!sceneHasLight && !this.dirLight && (this.config.useDirectionalLight || !this.config.useEnvironmentMap)) {
        this.scene.add(this.createDirLight());
      } else if (sceneHasLight) {
        // remove if the scene shipped its own light
        this.scene.remove(this.dirLight);
        delete this.dirLight;
      }
    }
  }, {
    key: "fixImportedScene",
    value: function fixImportedScene(scene) {
      var _this3 = this;
      scene.traverse(function (object) {
        if (object.isMesh) {
          object.castShadow = true;
        }
        if (object.isLight && object.target && _this3.ground) {
          object.target = _this3.ground;
          _this3.setLightShadow(object);
        }
      });
    }
  }, {
    key: "applyMaterialParams",
    value: function () {
      var _applyMaterialParams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(model, materialOptions, imageLoader) {
        var _this4 = this;
        var params;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!materialOptions) {
                _context3.next = 6;
                break;
              }
              params = materialOptions.params;
              _context3.t0 = params;
              if (!_context3.t0) {
                _context3.next = 6;
                break;
              }
              _context3.next = 6;
              return Promise.all(getAllMaterials(model).map( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(material) {
                  var materialName, materialNames;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        materialName = params.materialName, materialNames = params.materialNames; // check materialNames list if provided
                        if (!(materialNames instanceof Array && materialNames.indexOf(material.name) === -1)) {
                          _context2.next = 3;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 3:
                        if (!(materialName && material.name !== materialName)) {
                          _context2.next = 5;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 5:
                        _context2.next = 7;
                        return Promise.all(Object.keys(params).map( /*#__PURE__*/function () {
                          var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(p) {
                            var texture, value;
                            return _regeneratorRuntime().wrap(function _callee$(_context) {
                              while (1) switch (_context.prev = _context.next) {
                                case 0:
                                  if (!(params[p] === UNSET)) {
                                    _context.next = 2;
                                    break;
                                  }
                                  return _context.abrupt("return");
                                case 2:
                                  _context.t0 = p;
                                  _context.next = _context.t0 === "alphaMap" ? 5 : _context.t0 === "aoMap" ? 5 : _context.t0 === "emissiveMap" ? 5 : _context.t0 === "lightMap" ? 5 : _context.t0 === "map" ? 5 : _context.t0 === "metalnessMap" ? 5 : _context.t0 === "normalMap" ? 5 : _context.t0 === "roughnessMap" ? 5 : _context.t0 === "clearcoatMap" ? 5 : _context.t0 === "clearcoatNormalMap" ? 5 : _context.t0 === "clearcoatRoughnessMap" ? 5 : _context.t0 === "sheenRoughnessMap" ? 5 : _context.t0 === "sheenColorMap" ? 5 : _context.t0 === "specularIntensityMap" ? 5 : _context.t0 === "specularColorMap" ? 5 : _context.t0 === "thicknessMap" ? 5 : _context.t0 === "transmissionMap" ? 5 : _context.t0 === "aoMapIntensity" ? 15 : _context.t0 === "emissiveIntensity" ? 15 : _context.t0 === "envMapIntensity" ? 15 : _context.t0 === "lightMapIntensity" ? 15 : _context.t0 === "metalness" ? 15 : _context.t0 === "opacity" ? 15 : _context.t0 === "refractionRatio" ? 15 : _context.t0 === "roughness" ? 15 : _context.t0 === "attenuationDistance" ? 15 : _context.t0 === "clearcoat" ? 15 : _context.t0 === "clearcoatRoughness" ? 15 : _context.t0 === "ior" ? 15 : _context.t0 === "reflectivity" ? 15 : _context.t0 === "sheen" ? 15 : _context.t0 === "sheenRoughness" ? 15 : _context.t0 === "specularIntensity" ? 15 : _context.t0 === "thickness" ? 15 : _context.t0 === "transmission" ? 15 : _context.t0 === "color" ? 18 : _context.t0 === "emissive" ? 18 : _context.t0 === "attenuationColor" ? 18 : _context.t0 === "sheenColor" ? 18 : _context.t0 === "specularColor" ? 18 : 20;
                                  break;
                                case 5:
                                  texture = material[p] || material.map && material.map.clone() || new _three.Texture();
                                  _context.t1 = findImageBySrc(_this4.sceneContainer, "".concat(_this4._modelBasePath).concat(params[p]));
                                  if (_context.t1) {
                                    _context.next = 11;
                                    break;
                                  }
                                  _context.next = 10;
                                  return new Promise(function (resolve, reject) {
                                    return imageLoader.load(params[p], resolve, undefined, reject);
                                  });
                                case 10:
                                  _context.t1 = _context.sent;
                                case 11:
                                  texture.image = _context.t1;
                                  texture.needsUpdate = true;
                                  material[p] = texture;
                                  return _context.abrupt("break", 20);
                                case 15:
                                  value = parseFloat(params[p]);
                                  if (!isNaN(value)) {
                                    material[p] = value;
                                  }
                                  return _context.abrupt("break", 20);
                                case 18:
                                  material[p] = new _three.Color(params[p]);
                                  return _context.abrupt("break", 20);
                                case 20:
                                case "end":
                                  return _context.stop();
                              }
                            }, _callee);
                          }));
                          return function (_x5) {
                            return _ref7.apply(this, arguments);
                          };
                        }()));
                      case 7:
                        material.transparent = !!material.alphaMap;
                        material.needsUpdate = true;
                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x4) {
                  return _ref6.apply(this, arguments);
                };
              }()));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function applyMaterialParams(_x, _x2, _x3) {
        return _applyMaterialParams.apply(this, arguments);
      }
      return applyMaterialParams;
    }()
  }, {
    key: "applyCustomizations",
    value: function () {
      var _applyCustomizations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(model, item, imageLoader) {
        var _this5 = this;
        var options,
          _options$saveAndResto,
          saveAndRestore,
          params,
          materials,
          material,
          allMaterials,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
              _options$saveAndResto = options.saveAndRestore, saveAndRestore = _options$saveAndResto === void 0 ? true : _options$saveAndResto;
              params = item.params;
              if (params) {
                Object.keys(params).forEach(function (p) {
                  // skip not allowed props
                  if (allowedObjectProps.indexOf(p) === -1) {
                    return;
                  }
                  // restore original value first
                  if (params[p] === UNSET) {
                    if (model.originalValues && model.originalValues[p]) {
                      model[p].copy(model.originalValues[p]);
                    }
                    return;
                  }
                  // store original value for later restoration
                  if (!model.originalValues) {
                    model.originalValues = {};
                  }
                  if (!model.originalValues[p]) {
                    model.originalValues[p] = model[p] ? model[p].clone() : model[p];
                  }
                  // apply the param values
                  switch (p) {
                    case "scale":
                      {
                        var _params$p = params[p],
                          _params$p$x = _params$p.x,
                          x = _params$p$x === void 0 ? 1 : _params$p$x,
                          _params$p$y = _params$p.y,
                          y = _params$p$y === void 0 ? 1 : _params$p$y,
                          _params$p$z = _params$p.z,
                          z = _params$p$z === void 0 ? 1 : _params$p$z;
                        model[p].set(x, y, z);
                        break;
                      }
                    case "rotation":
                    case "position":
                      {
                        var _params$p2 = params[p],
                          _params$p2$x = _params$p2.x,
                          _x9 = _params$p2$x === void 0 ? 0 : _params$p2$x,
                          _params$p2$y = _params$p2.y,
                          _y = _params$p2$y === void 0 ? 0 : _params$p2$y,
                          _params$p2$z = _params$p2.z,
                          _z = _params$p2$z === void 0 ? 0 : _params$p2$z;
                        model[p].set(_x9, _y, _z);
                        break;
                      }
                  }
                });
              }

              // store & restore original material and textures before applying new param values
              saveAndRestore && Object.values(getMaterials(model)).map(function (mat) {
                if (!mat.original) {
                  mat.original = mat.clone();
                  Object.values(mat).filter(function (value) {
                    return value && value.isTexture;
                  }).forEach(function (texture) {
                    if (!texture.original) {
                      texture.original = texture.clone();
                    }
                  });
                } else {
                  mat.copy(mat.original);
                  Object.keys(mat).forEach(function (key) {
                    var value = mat[key];
                    if (value && value.original) {
                      value.copy(value.original);
                    }
                  });
                  mat.needsUpdate = true;
                }
              });

              // set new material params if provided
              // the material object should be located under item.params.material
              // item.material is only for backward compatibility
              materials = (params === null || params === void 0 ? void 0 : params.materials) || [];
              material = (params === null || params === void 0 ? void 0 : params.material) || item.material;
              allMaterials = [].concat(_toConsumableArray(materials), [material]).filter(function (v) {
                return v;
              });
              _context4.t0 = allMaterials.length;
              if (!_context4.t0) {
                _context4.next = 12;
                break;
              }
              _context4.next = 12;
              return Promise.all(allMaterials.map(function (material) {
                return _this5.applyMaterialParams(model, material, imageLoader);
              }));
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function applyCustomizations(_x6, _x7, _x8) {
        return _applyCustomizations.apply(this, arguments);
      }
      return applyCustomizations;
    }()
  }, {
    key: "loadSceneContainer",
    value: function loadSceneContainer(item) {
      var _this6 = this;
      var path;
      var itemType = _typeof(item);
      if ("string" === itemType) {
        path = item;
      } else if ("object" === itemType) {
        path = getSrc(item);
      }
      var _this$parseModelPath = this.parseModelPath(path),
        resourcePath = _this$parseModelPath.resourcePath,
        modelFileName = _this$parseModelPath.modelFileName;
      var loaderOptions = {
        basePath: this._modelBasePath,
        resourcePath: resourcePath
      };
      var modelLoader = this.createLoader(loaderOptions);
      var imageLoader = this.createImageLoader(loaderOptions);
      return new Promise(function (resolve, reject) {
        modelLoader.load(modelFileName, /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(gltf) {
            var model;
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  model = gltf.scene;
                  model.userData.path = path;
                  if (undefined !== item.index) {
                    model.userData.index = item.index;
                  }
                  _this6.fixImportedScene(model);
                  if (!("object" === itemType)) {
                    _context5.next = 7;
                    break;
                  }
                  _context5.next = 7;
                  return _this6.applyCustomizations(model, item, imageLoader);
                case 7:
                  resolve(gltf);
                case 8:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          return function (_x10) {
            return _ref8.apply(this, arguments);
          };
        }(), undefined, reject);
      });
    }
  }, {
    key: "findCustomizableMaterials",
    value: function findCustomizableMaterials(materialsObj) {
      var _iterator3 = _createForOfIteratorHelper(this._customizableMaterialKeys),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var key = _step3.value;
          var mat = materialsObj[key];
          if (mat) {
            this.prepareCustomCanvasForMaterial(mat);
            var index = (0, _findIndex["default"])(this._customizableMaterials, {
              name: key
            });
            if (index === -1) {
              this._customizableMaterials.push(mat);
            } else if (this._customizableMaterials[index] !== mat) {
              this._customizableMaterials[index] = mat;
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "initCustomizableMaterialsIfNeeded",
    value: function () {
      var _initCustomizableMaterialsIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var materials;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // reset customizable materials to always find the right one in the loaded scene
              this._customizableMaterialKeys.length = 0;
              this._customizableMaterials.length = 0;
              materials = getMaterials(this.sceneContainer);
              if ((0, _size["default"])(materials)) {
                this.guessCustomizableMaterialNameIfNotSet(materials);
                this.findCustomizableMaterials(materials);
              }
              _context6.next = 6;
              return this.dispatchMaterialUpdateEvent();
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function initCustomizableMaterialsIfNeeded() {
        return _initCustomizableMaterialsIfNeeded.apply(this, arguments);
      }
      return initCustomizableMaterialsIfNeeded;
    }()
  }, {
    key: "parseModelPath",
    value: function parseModelPath(path) {
      var matches = path.match(/([^/].+\/)([^/]+)/);
      if (!matches.length) {
        throw new Error("Model path cannot be parsed: " + path);
      }
      var resourcePath = "/" + matches[1];
      var modelFileName = matches[2];
      return {
        resourcePath: resourcePath,
        modelFileName: modelFileName
      };
    }
  }, {
    key: "loadSceneSync",
    value: function () {
      var _loadSceneSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(resourceList) {
        var result;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return this._loadScenePromise;
            case 3:
              _context7.next = 7;
              break;
            case 5:
              _context7.prev = 5;
              _context7.t0 = _context7["catch"](0);
            case 7:
              _context7.prev = 7;
              this._loadScenePromise = this.loadScene(resourceList);
              _context7.next = 11;
              return this._loadScenePromise;
            case 11:
              result = _context7.sent;
              _context7.next = 17;
              break;
            case 14:
              _context7.prev = 14;
              _context7.t1 = _context7["catch"](7);
              // remove promise if it is failed
              delete this._loadScenePromise;
            case 17:
              _context7.prev = 17;
              _context7.next = 20;
              return this.envMapPromise;
            case 20:
              _context7.next = 24;
              break;
            case 22:
              _context7.prev = 22;
              _context7.t2 = _context7["catch"](17);
            case 24:
              if (!this.isAnimating()) {
                this.render();
              }
              return _context7.abrupt("return", result);
            case 26:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 5], [7, 14], [17, 22]]);
      }));
      function loadSceneSync(_x11) {
        return _loadSceneSync.apply(this, arguments);
      }
      return loadSceneSync;
    }()
  }, {
    key: "loadScene",
    value: function () {
      var _loadScene = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resourceList) {
        var _this7 = this;
        var sceneContainer, _diffResourceLists, toBeRemoved, toBeAdded, toBeUpdated, toBeApplied, shouldResetScene, toBeDisposed, triggerLoadEvent, sceneParts, imageLoader, mixer, animations;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              sceneContainer = this.sceneContainer;
              this.stopAnimation();
              _diffResourceLists = diffResourceLists(this.currentResourceList || [], resourceList || []), toBeRemoved = _diffResourceLists.toBeRemoved, toBeAdded = _diffResourceLists.toBeAdded, toBeUpdated = _diffResourceLists.toBeUpdated, toBeApplied = _diffResourceLists.toBeApplied;
              shouldResetScene = toBeRemoved.length === this.currentResourceList.length;
              shouldResetScene && this.resetScene();
              this.currentResourceList = resourceList;
              toBeDisposed = [];
              toBeRemoved.forEach(function (item) {
                var itemSrc = getSrc(item);
                var object = findObjectWith(sceneContainer, function (_ref9) {
                  var userData = _ref9.userData;
                  return userData.path === itemSrc && userData.index === item.index;
                });
                if (object) {
                  object.parent.remove(object);
                  toBeDisposed.push(object);
                }
              });
              toBeDisposed.forEach(function (object) {
                return disposeNonUsedObjects(sceneContainer, object);
              });
              triggerLoadEvent = !!(toBeAdded.length || toBeUpdated.length || toBeApplied.length);
              triggerLoadEvent && this.onLoadStart();
              _context8.next = 13;
              return Promise.all(toBeAdded.map(function (item) {
                return _this7.loadSceneContainer(item);
              }));
            case 13:
              sceneParts = _context8.sent;
              sceneParts.forEach(function (_ref10) {
                var scene = _ref10.scene,
                  animations = _ref10.animations;
                sceneContainer.add(scene);

                // collect animations
                if (animations.length) {
                  var _this7$animations;
                  (_this7$animations = _this7.animations).push.apply(_this7$animations, _toConsumableArray(animations.filter(function (_ref11) {
                    var name = _ref11.name;
                    return !_this7.animations.find(function (_ref12) {
                      var existingName = _ref12.name;
                      return name !== existingName;
                    });
                  })));
                }
              });
              sceneContainer.updateWorldMatrix(true, true);
              _context8.next = 18;
              return Promise.all(toBeUpdated.map(function (item) {
                var itemSrc = getSrc(item);
                var object = findObjectWith(sceneContainer, function (_ref13) {
                  var userData = _ref13.userData;
                  return userData.path === itemSrc && userData.index === item.index;
                });
                var path = getSrc(item);
                var _this7$parseModelPath = _this7.parseModelPath(path),
                  resourcePath = _this7$parseModelPath.resourcePath;
                var loaderOptions = {
                  basePath: _this7._modelBasePath,
                  resourcePath: resourcePath
                };
                var imageLoader = _this7.createImageLoader(loaderOptions);
                return object && _this7.applyCustomizations(object, item, imageLoader);
              }));
            case 18:
              // apply global or targeted param values
              imageLoader = this.createImageLoader({
                basePath: this._modelBasePath
              });
              _context8.next = 21;
              return Promise.all(toBeApplied.map(function (_ref14) {
                var optionParams = _ref14.params,
                  files = _ref14.files;
                // find model based on objectName
                var objectName = optionParams.objectName,
                  _optionParams$materia = optionParams.material,
                  material = _optionParams$materia === void 0 ? {} : _optionParams$materia,
                  _optionParams$materia2 = optionParams.materials,
                  materials = _optionParams$materia2 === void 0 ? [] : _optionParams$materia2;
                var objects = objectName ? findAllObjectsWith(sceneContainer, function (_ref15) {
                  var name = _ref15.name;
                  return name === objectName;
                }) : sceneContainer.children;
                var params = material.params;
                var item = {
                  params: _objectSpread(_objectSpread({}, optionParams), {}, {
                    material: _objectSpread(_objectSpread({}, material), {}, {
                      params: params && mapObjectValues(params, files)
                    }),
                    materials: materials.map(function (material) {
                      return _objectSpread(_objectSpread({}, material), {}, {
                        params: material.params && mapObjectValues(material.params, files)
                      });
                    })
                  })
                };
                return Promise.all(objects.map(function (object) {
                  return _this7.applyCustomizations(object, item, imageLoader, {
                    saveAndRestore: false
                  });
                }));
              }));
            case 21:
              _context8.next = 23;
              return this.initCustomizableMaterialsIfNeeded();
            case 23:
              this.setupGround();
              this.addLightsIfNeeded(sceneContainer);
              this.fitSceneToCamera();
              this.initCameraViews(this.getCameras(sceneContainer));
              triggerLoadEvent && this.onLoadFinished();

              // start first animation
              if (this.animations.length) {
                mixer = this.mixer, animations = this.animations;
                mixer.stopAllAction();
                mixer.uncacheRoot(mixer.getRoot());
                mixer.clipAction(animations[0]).play();
                this.startAnimation("builtin");
              }
            case 29:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function loadScene(_x12) {
        return _loadScene.apply(this, arguments);
      }
      return loadScene;
    }()
  }, {
    key: "getCameras",
    value: function getCameras() {
      var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.sceneContainer;
      var cameras = [];
      tree.traverse(function (object) {
        if (object.isCamera) {
          cameras.push(object);
        }
      });
      return cameras;
    }
  }, {
    key: "setupSceneCameras",
    value: function setupSceneCameras(cameras, center) {
      var _iterator4 = _createForOfIteratorHelper(cameras),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _camera$userData;
          var camera = _step4.value;
          var position = camera.getWorldPosition(new _three.Vector3());
          var dir = camera.getWorldDirection(new _three.Vector3());
          var distance = position.distanceTo(center);
          var lookat = dir.multiplyScalar(distance).add(position);
          var rotation = new _three.Quaternion();
          camera.getWorldQuaternion(rotation);
          var orientation = _three.Object3D.DefaultUp.clone();
          var fov = camera.fov || 45;
          var cameraView = {
            position: position,
            lookat: lookat,
            orientation: orientation,
            fov: fov
          };
          var cameraName = (_camera$userData = camera.userData) === null || _camera$userData === void 0 ? void 0 : _camera$userData.name;
          if (!cameraName) {
            continue; // cannot identify, ignore
          }
          // map camera views to component names (with the objectName:useFor=component1,component2 name)
          var matches = cameraName.match(/:useFor=(([^,]+,?)+)/);
          var componentIdentifiers = matches && matches[1] && matches[1].split(",");
          if (componentIdentifiers) {
            var _iterator5 = _createForOfIteratorHelper(componentIdentifiers),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var componentIdentifier = _step5.value;
                // remove _Orientation suffix added by blender gltf exporter
                this.cameraViews[componentIdentifier.replace("_Orientation", "")] = cameraView;
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          } else if (cameraName.startsWith("screenshot_")) {
            this.screenshotViews[cameraName.replace("screenshot_", "")] = cameraView;
          } else {
            this.cameraViews[cameraName] = cameraView;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "calculateRelativeViews",
    value: function calculateRelativeViews(viewsObj, center, distance) {
      var views = {};
      for (var _i3 = 0, _Object$keys = Object.keys(viewsObj); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        var view = _objectSpread(_objectSpread({}, viewsObj["default"]), viewsObj[key]);
        var position = center.clone().add(view.position.clone().multiplyScalar(distance));
        var lookat = center.clone().add(view.lookat);
        views[key] = _objectSpread(_objectSpread({}, view), {}, {
          position: position,
          lookat: lookat
        });
      }
      return views;
    }
  }, {
    key: "setupRelativeCameras",
    value: function setupRelativeCameras(center) {
      if (!this.relativeCameraViews["default"]) {
        this.relativeCameraViews["default"] = {
          position: this.defaultCameraPosition.clone(),
          lookat: new _three.Vector3(0, 0, 0),
          orientation: new _three.Vector3(0, 1, 0)
        };
      }
      this.cameraViews = this.calculateRelativeViews(this.relativeCameraViews, center, this.controls.maxDistance * 0.75);
      if (!this.relativeScreenshotViews["default"]) {
        this.relativeScreenshotViews["default"] = {
          position: this.defaultScreenshotPosition.clone(),
          lookat: new _three.Vector3(0, 0, 0),
          orientation: new _three.Vector3(0, 1, 0)
        };
      }
      this.screenshotViews = this.calculateRelativeViews(this.relativeScreenshotViews, center, (this.controls.minDistance + this.controls.maxDistance) * 0.5);
    }
  }, {
    key: "getCameraViewRatio",
    value: function getCameraViewRatio(view1, view2) {
      return view2.lookat.distanceTo(view2.position) / view1.lookat.distanceTo(view1.position);
    }
  }, {
    key: "shouldViewChangeTriggerJumpToView",
    value: function shouldViewChangeTriggerJumpToView(view1, view2) {
      var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
      return Math.abs(this.getCameraViewRatio(view1, view2) - 1) > tolerance;
    }
  }, {
    key: "initCameraViews",
    value: function initCameraViews(cameras) {
      var _this$sceneContainer;
      if (!((_this$sceneContainer = this.sceneContainer) !== null && _this$sceneContainer !== void 0 && (_this$sceneContainer = _this$sceneContainer.children) !== null && _this$sceneContainer !== void 0 && _this$sceneContainer.length)) {
        return;
      }
      if (!this.controls) {
        return;
      }
      var box = this.getSceneContainerBox();
      var center = box.getCenter(new _three.Vector3());
      var currentCameraName = this.currentCameraView;
      var previousCameraView = this.cameraViews[currentCameraName];
      this.setupRelativeCameras(center);
      this.setupSceneCameras(cameras, center);
      if (!this._firstCameraInitDone) {
        this._firstCameraInitDone = true;
        this.currentCameraView = null;
        this.jumpToView("default", false);
      } else if (previousCameraView && this.cameraViews[currentCameraName] && this.shouldViewChangeTriggerJumpToView(previousCameraView, this.cameraViews[currentCameraName])) {
        this.currentCameraView = null;
        this.jumpToView(currentCameraName, true);
      }
    }
  }, {
    key: "jumpToView",
    value: function jumpToView(viewName) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!this.cameraViews[viewName]) {
        viewName = "default";
      }
      if (this.currentCameraView === viewName) {
        return;
      }
      this.currentCameraView = viewName;
      var view = this.cameraViews[viewName];
      if (!view) {
        return;
      }
      var position = view.position,
        orientation = view.orientation,
        target = view.lookat,
        fov = view.fov;
      if (animate) {
        this.moveCamera(position, orientation, target, fov, duration);
      } else {
        this.setCameraPosition(position, orientation, target, fov);
      }
    }
  }, {
    key: "resetScene",
    value: function resetScene() {
      this.mixer.stopAllAction().uncacheRoot(this.mixer.getRoot());
      this.sceneContainer.scale.set(1, 1, 1);
      this.defaultCamera = null;
      this.animations.length = 0;
      this._customizableMaterialKeys.length = 0;
      this._customizableMaterials.length = 0;
    }
  }, {
    key: "isGroundObject",
    value: function isGroundObject(object) {
      return this.groundObjectNames.some(function (pattern) {
        var _object$material;
        return pattern.test(object.name) || pattern.test((_object$material = object.material) === null || _object$material === void 0 ? void 0 : _object$material.name);
      });
    }
  }, {
    key: "findGroundObject",
    value: function findGroundObject() {
      var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.sceneContainer;
      var _iterator6 = _createForOfIteratorHelper(root.children),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var object = _step6.value;
          if (this.isGroundObject(object)) {
            return object;
          }
          var ground = this.findGroundObject(object);
          if (ground) {
            return ground;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return null;
    }
  }, {
    key: "setupGround",
    value: function setupGround() {
      this.sceneGround = this.findGroundObject();
      if (this.sceneGround && this.ground) {
        this.scene.remove(this.ground);
        this.ground = null;
      } else if (!this.sceneGround && this.config.useShadowGround) {
        this.scene.add(this.createGround());
      }
    }
  }, {
    key: "getSceneContainerBox",
    value: function getSceneContainerBox() {
      var _this$sceneGround;
      var groundParent = (_this$sceneGround = this.sceneGround) === null || _this$sceneGround === void 0 ? void 0 : _this$sceneGround.parent;
      groundParent === null || groundParent === void 0 || groundParent.remove(this.sceneGround);
      var box = new _three.Box3();
      this.sceneContainer.traverse(function (object) {
        if (object.isMesh) {
          box.expandByObject(object);
        }
      });
      groundParent === null || groundParent === void 0 || groundParent.add(this.sceneGround);
      return box;
    }
  }, {
    key: "fitSceneToCamera",
    value: function fitSceneToCamera() {
      var controls = this.controls,
        camera = this.camera,
        ground = this.ground,
        dirLight = this.dirLight,
        hemiLight = this.hemiLight;
      var box = this.getSceneContainerBox();
      var fitOffset = 1.2;
      var sphere = new _three.Sphere();
      box.getBoundingSphere(sphere);
      if (sphere.radius < 0.001) {
        return;
      }
      var minDistance = sphere.radius;
      var fitDistance = sphere.radius / Math.atan(Math.PI * camera.fov / 360);
      var distance = fitOffset * fitDistance;
      var maxDistance = Math.max(minDistance * 5, distance * 1.5);

      // update scene objects
      if (ground) {
        ground.position.y = box.min.y;
        ground.position.x = sphere.center.x;
        ground.position.z = sphere.center.z;
        var groundScaling = this.config.useBakedShadows ? sphere.radius * 4 : maxDistance * 2;
        ground.scale.set(1, 1, 1).multiplyScalar(groundScaling);
      }
      if (dirLight) {
        dirLight.position.copy(this.dirLightPosition).multiplyScalar(maxDistance).add(sphere.center);
        this.scene.add(dirLight.target);
        dirLight.target.position.copy(sphere.center);
        this.setLightShadow(dirLight, minDistance);
      }
      if (hemiLight) {
        hemiLight.position.y = maxDistance;
      }

      // update controls
      if (minDistance === controls.minDistance) {
        return;
      }
      controls.minDistance = minDistance;
      controls.maxDistance = maxDistance;
      camera.near = minDistance * 0.01;
      camera.far = maxDistance * 100;
      // update current position only if it does not fit into the distance range
      var currentDistance = sphere.center.distanceTo(camera.position);
      if (currentDistance < minDistance || currentDistance > maxDistance) {
        camera.position.copy(camera.position.normalize().multiplyScalar(maxDistance * 0.75));
        controls.target = sphere.center;
      }
      camera.updateProjectionMatrix();
      controls.update();
    }
  }, {
    key: "setActiveAnimation",
    value: function setActiveAnimation(animationName) {
      var animation = this.animations.find(function (_ref16) {
        var name = _ref16.name;
        return name === animationName;
      });
      if (animation) {
        this.mixer.stopAllAction().clipAction(animation).play();
      }
    }
  }, {
    key: "getAnimations",
    value: function getAnimations() {
      return this.animations;
    }
  }, {
    key: "setActiveCamera",
    value: function setActiveCamera(cameraName) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$updateContro = options.updateControls,
        updateControls = _options$updateContro === void 0 ? false : _options$updateContro,
        _options$setAsDefault = options.setAsDefault,
        setAsDefault = _options$setAsDefault === void 0 ? false : _options$setAsDefault,
        _options$rerender = options.rerender,
        rerender = _options$rerender === void 0 ? true : _options$rerender;
      var originalCamera = !cameraName || cameraName === "default" ? this.defaultCamera : this.scene.getObjectByName(cameraName);
      if (originalCamera) {
        var view = this.camera.view;
        var camera = originalCamera.clone();
        camera.view = view;
        setCameraAspectFromRendererSize(camera, this.renderer);
        this.camera = camera;
        camera.updateProjectionMatrix();
        if (updateControls && this.controls) {
          this.controls.object = camera;
        }
        if (setAsDefault) {
          this.defaultCamera = originalCamera;
        }
        if (rerender) {
          this.render();
        }
      }
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(configuration) {
        var sceneData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this._configuration = configuration;
              sceneData = (0, _get["default"])(configuration, "visualizationData.sceneData", false) || (0, _get["default"])(configuration, "visualizationData.designViews[0].models.".concat(this._materialVariantPath), false);
              _context9.t0 = sceneData;
              if (!_context9.t0) {
                _context9.next = 6;
                break;
              }
              _context9.next = 6;
              return this.loadSceneSync(sceneData);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function update(_x13) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "updateMaterial",
    value: function () {
      var _updateMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var sceneData;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              sceneData = (0, _get["default"])(this._designAreaList, "[0].designView.models.".concat(this._materialVariantPath)) || (0, _get["default"])(this._configuration, "visualizationData.designViews[0].models.".concat(this._materialVariantPath)) || false;
              _context10.t0 = sceneData;
              if (!_context10.t0) {
                _context10.next = 5;
                break;
              }
              _context10.next = 5;
              return this.loadSceneSync(sceneData);
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function updateMaterial() {
        return _updateMaterial.apply(this, arguments);
      }
      return updateMaterial;
    }()
  }, {
    key: "updateDesignAreaList",
    value: function () {
      var _updateDesignAreaList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(designAreaList) {
        var sceneData;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this._designAreaList = designAreaList;
              sceneData = (0, _get["default"])(designAreaList, "[0].designView.models.".concat(this._materialVariantPath));
              _context11.t0 = sceneData;
              if (!_context11.t0) {
                _context11.next = 6;
                break;
              }
              _context11.next = 6;
              return this.loadSceneSync(sceneData);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function updateDesignAreaList(_x14) {
        return _updateDesignAreaList.apply(this, arguments);
      }
      return updateDesignAreaList;
    }()
  }, {
    key: "exportGLTF",
    value: function exportGLTF() {
      (0, _glTFExporter.exportGLTF)(this.sceneContainer);
    }
  }, {
    key: "setupScreenshots",
    value: function setupScreenshots() {
      var ground = this.ground || this.sceneGround;
      if (ground && this.config.removeGroundForScreenshot) {
        var groundVisibility = ground.visible;
        ground.visible = false;
        return function () {
          ground.visible = groundVisibility;
        };
      }
      return function () {};
    }
  }]);
  return Three3DScene;
}(_Three3D2.Three3D);